import { apiClient } from './client'

export interface AdminTicket {
  id: number
  uuid: string
  event_id: number
  event_name: string | null
  ticket_type: string | null
  ticket_type_id: number
  buyer_name: string | null
  buyer_phone: string
  quantity: number
  unit_price: number
  total_price: number
  status: string
  qr_code_url: string | null
  whatsapp_sent: boolean
  whatsapp_sent_at: string | null
  purchased_at: string | null
  created_at: string
}

interface TicketsResponse {
  data: AdminTicket[]
  meta: {
    current_page: number
    per_page: number
    total: number
    last_page: number
  }
}

export const ticketsApi = {
  list: async (params?: {
    page?: number
    per_page?: number
    event_id?: number
    status?: string
    phone?: string
  }): Promise<TicketsResponse> => {
    const { data } = await apiClient.get('/admin/tickets', { params })
    return { data: data.data, meta: data.meta }
  },

  resendWhatsApp: async (uuid: string): Promise<void> => {
    await apiClient.post(`/admin/tickets/${uuid}/resend-whatsapp`)
  },
}
